// import { API_BASE_URL, BEARER_TOKEN_V2 } from './apiConfig';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const BEARER_TOKEN = process.env.REACT_APP_BEARER_TOKEN_V2 || '';

interface TextToVoiceResponse {
	timestamp: string;
	status: string;
	code: number;
    audio_base64: string;
    message: string;
    output_format: string;
}

const textToVoice = async (
	message: string,
	appId: string
): Promise<TextToVoiceResponse> => {
	const apiUrl = `${API_BASE_URL}/v2/application/text-to-voice`;
	try {
		const requestOptions: RequestInit = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Bearer: `${BEARER_TOKEN}`,
				base_app_id: appId
			},
			body: JSON.stringify({text: message}),
		};

		const response = await fetch(apiUrl, requestOptions);

		if (!response.ok) {
			if (response.status === 504) {
				throw new Error('Error al contactar con el servidor. Inténtalo de nuevo más tarde.');
			}
			const data = await response.json();
			if (data.body) {
				const parsedBody = JSON.parse(data.body);
				throw new Error(parsedBody.message || 'Error al contactar con el servidor. Inténtalo de nuevo más tarde.');
			}
			throw new Error(data.message || 'Error al contactar con el servidor. Inténtalo de nuevo más tarde.');
		}

		const data = await response.json();
		return data as TextToVoiceResponse;
	} catch (error) {
		console.error('Error:', error);
		throw error;
	}
};

export default textToVoice;
